import { User } from '../../types.inspections';

export const inspectionKeys = ['serial', 'operating_hours', 'inspector', 'inspection_location', 'label'];

export const createAssigneeEmails = (assignee: string[], users: User[]) => {
  return assignee.map(
    (singleAssignee) => users?.find(({ id }) => id === singleAssignee)?.email,
  );
};
